import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';

import * as S from './styles';

type OwnProps = {
  className?: string;
  src: string;
  year?: number | null;
  width?: number;
};

const Badge = ({ className, src, year, width = 128 }: OwnProps) => {
  const { market, t } = useContext(AppContext);

  // replaces soty badges img urls from 2010, 2011 and 2012 with generic badge
  // because badges for those years are missing on cdn.
  const imgSrc =
    year && year < 2013
      ? `${market.cdn}/g/store_of_the_year/generic_store_of_the_year.png`
      : src;
  const altText = t('campaigns', 'shop-of-the-year.title-with-year', {
    year: year || '',
  });

  return (
    <S.Badge
      className={className}
      src={imgSrc}
      alt={altText}
      title={altText}
      width={width}
    />
  );
};

export default Badge;
